import { reportRecoverableError } from '../core/diagnostics'

const PREFIX = 'sn:'

function available(): boolean {
  try {
    const key = '__sn_test__'
    window.localStorage.setItem(key, '1')
    window.localStorage.removeItem(key)
    return true
  }
  catch (error: unknown) {
    reportRecoverableError('localStorage is unavailable', error)
    return false
  }
}

const canUseStorage = available()

export function get<T = unknown>(key: string, fallback?: T): T | undefined {
  if (!canUseStorage)
    return fallback
  const raw = window.localStorage.getItem(PREFIX + key)
  if (raw === null)
    return fallback
  try {
    return JSON.parse(raw) as T
  }
  catch (error: unknown) {
    reportRecoverableError(`stored value "${key}" is not valid JSON`, error)
    return fallback
  }
}

export function set(key: string, value: unknown): boolean {
  if (!canUseStorage)
    return false
  try {
    window.localStorage.setItem(PREFIX + key, JSON.stringify(value))
    return true
  }
  catch (error: unknown) {
    reportRecoverableError(`failed to write stored value "${key}"`, error)
    return false
  }
}

export function remove(key: string): void {
  if (!canUseStorage)
    return
  window.localStorage.removeItem(PREFIX + key)
}
